import React, { useState, useEffect } from "react"
import { useSearchParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { alertaGeneral } from "../../utils/alertas";
import apiClient from "../../utils/axiosPetition";

const PagRespuestaAfiliadoPayU = () => {
    const data = JSON.parse(localStorage.getItem('registro-data')) || {};
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [transactionState] = searchParams.get('transactionState');
    const [isApproved, setIsApproved] = useState(false);

    console.log(transactionState, 'transactionState');
    console.log(isApproved, 'isApproved');

    useEffect(() => {
        if (transactionState === "4" && !isApproved) {
            // Normalizar email a minúsculas
            const normalizedData = { ...data, email: data.email ? data.email.toLowerCase().trim() : data.email };
            
            apiClient.post(`/api/afiliado/registro`, normalizedData)
                .then(res => {
                    alertaGeneral({
                        titulo: 'Transacción Aprobada',
                        messageHtml: 'Se le han enviado las credenciales al correo ' + data.email,
                    });
                    setIsApproved(true);
                    localStorage.removeItem('registro-data');
                    navigate('/login');
                }).catch(error => {
                    alertaGeneral({
                        titulo: 'Error',
                        messageHtml: error.response?.data?.message || 'No se pudo registrar el afiliado',
                        isError: true,
                    })
                })
        } else if (transactionState !== "4") {
            alertaGeneral({
                titulo: 'Error',
                messageHtml: 'La transaccion no se aprobo',
                isError: true
            });
            navigate('/registro', { state: { tipoRegistro: 'Afiliado', data: data } });
        }
    }, [transactionState, isApproved]);
}

export default PagRespuestaAfiliadoPayU